<template>
  <div class="checkin">
    <checkin-stepper v-if="!is_guest"/>

    <v-container class="checkin">
      <v-card-text>
        <h2 v-if="is_guest">{{ $t("recognition.title") }}</h2>
        <v-container class="recognition">
          <div v-if="guests && guests.length > 0 "
            class="recognition-label-count"
            :class="guests.length == guest_recognized ? 'identified' : 'waiting'">{{ $t("recognition.mandatory_recognition") }} {{guest_recognized}}/{{guests.length}}</div>
          <v-expansion-panels v-model="panel">
            <v-expansion-panel v-for="(guest, index) in guests" :key="index" >
              <v-expansion-panel-header class="font-weight-bold" :disable-icon-rotate="disableRotateIcon(guest)">
                <template v-slot:actions>
                  <v-icon color="success" v-if="guest.recognition_state && !recognitionIsWaiting(guest)">
                    mdi-check-circle
                  </v-icon>
                  <v-icon color="error" v-else-if="recognitionIsRefused(guest)">
                    mdi-close-octagon
                  </v-icon>
                  <v-icon color="warning" v-else-if="recognitionIsWaiting(guest)">
                    mdi-timer-sand
                  </v-icon>
                </template>
                {{ $t("recognition.guest") }} {{index + 1}}: {{ guest.last_name }} {{ guest.first_name }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container class="summary_guest_recognition" v-if="!processStart" id="guests_list">

                  <v-container class="justify-center pt-6 pb-10">
                    <p class="text-center">
                      {{ $t("recognition.prepare_recognition") }}
                    </p>
                    <v-container class="image_guest_recognition" v-if="reservation.reservation_documents[guest.id]">
                      <v-row class="justify-space-around">
                        <v-col class="col-guest custom-width">
                          <p>{{ $t("recognition.face_document") }}</p>
                          <img width="200" height="200" v-if="reservation.reservation_documents[guest.id][0]"
                               :src="reservation.reservation_documents[guest.id][0].url"
                               :alt="reservation.reservation_documents[guest.id][0].name"
                               class="state"
                               :class="guestImageState(guest, reservation.reservation_documents[guest.id][0].id ) "
                                >
                          <v-btn v-if="[waiting, refused].includes(guest.recognition_state)"
                            class="full_width"
                            :disabled="guest.recognition_state == identified"
                            @click="startPhotoProcess(index, 0)" >
                            {{ $t("recognition.take_again") }}
                          </v-btn>
                        </v-col>

                        <v-col class="col-guest custom-width">
                          <p>{{ $t("recognition.front_document") }}</p>
                          <img width="200" height="200" v-if="reservation.reservation_documents[guest.id][1]"
                               :src="reservation.reservation_documents[guest.id][1].url"
                               :alt="reservation.reservation_documents[guest.id][1].name"
                               class="state"
                               :class="guestImageState(guest, reservation.reservation_documents[guest.id][1].id )">
                          <v-btn v-if="[waiting, refused].includes(guest.recognition_state)"
                            class="full_width"
                            :disabled="guest.recognition_state == identified"
                            @click="startPhotoProcess(index, 1)" >
                            {{ $t("recognition.take_again") }}
                          </v-btn>

                        </v-col>

                        <v-col class="col-guest custom-width">
                          <p>{{ $t("recognition.back_document") }}</p>
                          <img width="200" height="200" v-if="reservation.reservation_documents[guest.id][2]"
                               :src="reservation.reservation_documents[guest.id][2].url"
                               :alt="reservation.reservation_documents[guest.id][2].name"
                               :disabled="guest.recognition_state == identified"
                               class="state"
                               :class="guestImageState(guest, reservation.reservation_documents[guest.id][2].id )"
                          >
                          <v-btn v-if="[waiting, refused].includes(guest.recognition_state)"
                            class="full_width"
                            :disabled="guest.recognition_state == identified"
                            @click="startPhotoProcess(index, 2)" >
                            {{ $t("recognition.take_again") }}
                          </v-btn>
                        </v-col>



                      </v-row>

                      <div class="pt-4" v-if="guest.recognition_reason && guest.recognition_reason['reason']">
                        <h4>{{ $t("recognition.refused_title") }}</h4>
                        <p>
                          {{ guest.recognition_reason['reason'] }}
                        </p>
                      </div>
                    </v-container>
                    <v-row class="justify-center pt-6" v-if="!reservation.reservation_documents[guest.id] || (reservation.reservation_documents[guest.id] && reservation.reservation_documents[guest.id].length!=3)">
                      <v-btn
                        :disabled="guest.recognition_state == identified"
                        @click="startPhotoProcess(index)" >
                        {{ $t("recognition.start_recognition")}}
                      </v-btn>
                    </v-row>

                  </v-container>
                  <v-container v-if="(!is_guest && index != 0)" >
                    <hr>
                    <p class="font-weight-bold text-center pt-6">
                      {{ $t("recognition.share_recognition", {name: (guest.last_name +" "+guest.first_name)} ) }}
                    </p>
                    <v-row class="justify-space-around pt-6">
                      <v-btn
                        min-width="180"
                        target="_blank"
                        :href="whatsappUrl(guest)"
                        :disabled="guest.recognition_state == identified" >
                        <v-icon class="pr-3" >mdi-whatsapp</v-icon> Via whatsapp
                      </v-btn>
                      <v-btn
                        min-width="180"
                        target="_blank"
                        :href="sendEmail(guest)"
                        :disabled="guest.recognition_state == identified" >
                        <v-icon class="pr-3">mdi-email-outline</v-icon> Via email
                      </v-btn>

                    </v-row>

                  </v-container>
                </v-container>
                <v-container v-else class="process_guest_recognition">
                  <CheckinDataPhoto :recipient="guest_to_recognition"
                                    :order_id = "order.id"
                                    :reservation_id = "reservation.id"
                                    :index_photo = "singlePhoto"
                                    @update-start-processing = "updateProcessStart"
                                    @update-url-photo = "updateUrlPhoto" />
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-card-text>
    </v-container>

    <checkin-bottom-navigation v-if="!is_guest">
      <template v-slot:prev-button>
        <v-btn @click="goToPrevStepper">
          {{ $t("commons.prev") }}
        </v-btn>
      </template>
      <template v-slot:next-button>
        <v-btn v-if = "!isTheEnd"
               @click="goToNextStepper"
               color="primary"
               :disabled="(!isRecognitionCompleted && !isRoomChiefRecognized && !disableButton(room_chief)) || processStart"
               :loading='submitting'
        >
          {{ $t("commons.next") }}
        </v-btn>
        <v-btn
          v-else-if="formAndMandatoryStepsCompleted && isRecognitionCompleted"
          @click="completeCheckin()"
          color="success"
          :disabled="(!isRecognitionCompleted && !isRoomChiefRecognized  && !disableButton(room_chief)) || processStart"
          :loading='submitting'
        >
          {{ $t("commons.end") }}
        </v-btn>
        <v-btn
          v-else
          @click="completeCheckin()"
          :disabled="(!isRecognitionCompleted && !isRoomChiefRecognized && !disableButton(room_chief)) || processStart"
          color="primary"
          :loading='submitting'
        >
          {{ $t("commons.close_checkin") }}
        </v-btn>
      </template>
    </checkin-bottom-navigation>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CheckinStepper from '../../checkin/checkin_stepper'
import CheckinDataPhoto from './checkin_data_photo'
import CheckinBottomNavigation from '../../checkin/checkin_bottom_navigation'
import { orderFetchMixin } from '../../../mixins/order_fetch_mixin'
import { orderMethodsMixin } from '../../../mixins/order_methods_mixin'

export default {
  name: 'CheckinRecognition',

  components: {
    CheckinStepper,
    CheckinBottomNavigation,
    CheckinDataPhoto
  },
  data() {
    return {
      panel: 0,
      waiting: 'waiting',
      identified: 'identified',
      refused: 'refused',
      is_guest: null,
      room_chief_label: ["SINGLE", "GROUP_HEAD", "FAMILY_HEAD"],
      recognizedRoomChief: false,
      processStart: null,
      guest_to_recognition: null,
      room_chief: false,
      guest_with_image_sent: [],
      image_in_waiting_temp: [],
      guests: [],
      guest_recognized: 0,
      singlePhoto: null
    }
  },
  mixins: [
    orderFetchMixin,
    orderMethodsMixin
  ],
  async created() {

    await this.fetchOrder(this.currentOrderId).then(() => {
      const _this = this
      _this.is_guest = _this.guestIdByUrl()
      if(_this.is_guest){

        _this.guests = _this.reservation.guests.filter((guest) => {
          return guest.id == _this.is_guest
        })
      }else{
        _this.guests = _this.reservation.guests
        _this.guests.map((guest) => {
          if ([_this.waiting, _this.identified].includes(guest.recognition_state)) {
            _this.guest_recognized +=1
          }
        })
      }

      _this.room_chief = _this.reservation.guests.filter((guest) => {
        return _this.room_chief_label.includes(guest.typology) })[0]


    })

  },
  computed: {
    ...mapState('layout', ['loading', 'currentStep', 'submitting', 'completedCheckinSteps']),
    ...mapState('order', ['order']),

    headers() {
      return  [
        {text: this.$t("recognition.name"), value:"name", sortable:false},
        {text: this.$t("recognition.role"), value:"role", sortable:false},
        {text: this.$t("recognition.recognition"), value:"recognition", sortable:false},
        {text: this.$t("recognition.start_recognition"), value:"start_recognition", sortable:false},
        {text: this.$t("recognition.share"), value:"share", sortable:false}
      ]
    },

    formAndMandatoryStepsCompleted() {
      return this.completedCheckinSteps && this.completedCheckinSteps.every((step) => (step.mandatory || typeof(step.mandatory) == 'undefinded') ? step.completed : true )
    },
    presenceRemovableSteps(){
      return this.completedCheckinSteps.some(step => ['contract', 'payment'].includes(step.name))
    },
    isTheEnd() {
      return !!this.reservation && !this.presenceRemovableSteps
    },
    isRecognitionCompleted(){
      return this.completedCheckinSteps[this.currentStep - 1]?.complete
    },
    isRoomChiefRecognized(){
      if (this.room_chief){
        return [this.identified].includes(this.room_chief.recognition_state)
      }

    }
  },
  methods: {
    ...mapActions('layout', ['goToPrevStepper', 'goToNextStepper']),
    startPhotoProcess(index, index_photo = null){
      this.guest_to_recognition = this.guests[index]
      if (index_photo || index_photo === 0){
        this.singlePhoto = index_photo
      }
      this.processStart = true
    },
    whatsappUrl(guest){
      let textToSend = window.location + '?guest=' + guest.id
      let guest_name = guest.last_name+" "+guest.first_name
      let room_chief_name = this.room_chief.last_name+" "+this.room_chief.first_name
      let url = "https://api.whatsapp.com/send?text=" + this.$t("recognition.body_text", {url: textToSend, guest_name: guest_name, room_chief_name: room_chief_name}) + "&source=&data=&app_absent="
      return url
    },
    sendEmail(guest){
      let textToSend = window.location + '?guest=' + guest.id
      let guest_name = guest.last_name+" "+guest.first_name
      let room_chief_name = this.room_chief.last_name+" "+this.room_chief.first_name
      let url = "mailto:?&subject=" + this.$t("recognition.subject") + "&body=" + this.$t("recognition.body_text", {url: textToSend, guest_name: guest_name, room_chief_name: room_chief_name})
      return url
    },
    recognitionIsRefused(guest){
      return !!this.reservation && guest.recognition_state == this.refused
    },
    recognitionIsWaiting(guest){
      return !!this.reservation && (guest.recognition_state == this.waiting || guest.recognition_state == this.refused || this.guest_with_image_sent.includes(guest.id))
    },
    disableButton(guest){
      return !!this.reservation && ((this.guest_with_image_sent.includes(guest.id) && this.image_in_waiting_temp.length == 3) || this.reservation.reservation_documents[guest.id])
    },
    disableRotateIcon(guest){
      return (guest.recognition_state && !this.recognitionIsWaiting(guest)) || this.recognitionIsRefused(guest) || this.recognitionIsWaiting(guest)
    },
    updateUrlPhoto(guest_state, info_image, guest_id){
      let reservation_id = this.reservation.id
      let single_photo = this.singlePhoto
      this.image_in_waiting_temp.push(info_image.id)
      this.$store.commit('order/UPDATE_RESERVATION_IMAGE', {reservation_id, guest_state, info_image, guest_id})
    },
    updateProcessStart(process, guest_id){
      if (!this.guest_with_image_sent.includes(guest_id)){
        this.guest_with_image_sent.push(guest_id)
      }
      if (guest_id == this.room_chief.id){
        this.recognizedRoomChief = true
      }
      this.updateCount()
      this.singlePhoto = null
      this.processStart = !process
    },
    updateCount(){
      this.guest_recognized = 0
      this.guests.map((guest) => {
        if((guest.recognition_state && !this.recognitionIsWaiting(guest)) || this.recognitionIsWaiting(guest)) {
          this.guest_recognized +=1
        }
      })

    },
    guestIdByUrl(){
      const queryString = window.location.search
      const params = new URLSearchParams(queryString)
      return parseInt(params.get('guest'))
    },
    guestImageState(guest, asset_id){
      let state = guest.recognition_state ? guest.recognition_state : this.waiting
      if(this.guest_with_image_sent.includes(asset_id)){
        state = this.waiting
      }
      let photos_refused = (guest.recognition_reason && guest.recognition_reason['photo_index']) ? guest.recognition_reason['photo_index'] : null
      if(state == this.refused && photos_refused){
        state = !photos_refused.includes(asset_id.toString()) ? this.waiting : this.refused
      }
      return state
    }
  }


}
</script>

<style>
  .v-card.recognition{
    max-width: 800px;
    margin: 0 auto;
  }
  h2{
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 10px;
  }

  .state{
    border: 5px solid transparent;
  }
  .state.identified{
    pointer-events: none;
    border-color: #4CAF50 ;
  }
  .state.refused{
    border-color: #FF5252;
  }
  .state.waiting{
    border-color: #FFC107;
  }

  .recognition-label-count{
    font-weight: bold;
    padding: 10px;
    border: 1px solid;
    width: 33%;
    margin: 0 auto 20px;
    border-radius: 10px;
    text-align: center;
    justify-content: center;
  }
  .recognition-label-count.waiting{
    border-color: #FFC107;
    background-color: #FFC107;
  }
  .recognition-label-count.identified{
    border-color: #4CAF50;
    background-color: #4CAF50;
  }

  #guests_list table{
    border: 1px solid rgba(0, 0, 0, .12);
  }
  #guests_list table tr.img-row td{
    border-bottom: 1px solid rgba(0, 0, 0, .12);
  }

  #guests_list table tbody:last-child tr.img-row td{
    border-bottom: 0;
  }

  #guests_list thead th,
  #guests_list td{
    border-right: 1px solid rgba(0, 0, 0, .12);
  }

  div.custom-width{
    width: 250px;
    max-width: 250px;
    text-align:center;
  }
  div.col-guest p{
    margin-bottom: 0;
    font-weight: bold;
  }


  div.custom-width .full_width{
    width: 100%;
  }
  div img{
    padding: 5px;
    margin: 5px;
  }
  div img.error{
    border: 5px solid red;
  }

  #guests_list div .v-input__slot:before,
  #guests_list div .v-input__slot:after{
    border: 0;
    border-color: transparent;
  }
  #guests_list thead th:last-child,
  #guests_list td:last-child{
    border-right: 0px ;
  }
</style>
